import React from 'react';
import IconBase from './IconBase';

const AdminAddIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M17,10.5c0.9,0,1.7,0.2,2.5,0.5V6.6c0-0.4-0.1-0.7-0.3-1C19,5.2,18.7,5,18.3,4.9l-5.7-2.1c-0.2-0.1-0.4-0.1-0.6-0.1s-0.4,0-0.6,0.1L5.7,4.9C5.3,5,5,5.2,4.8,5.5s-0.3,0.6-0.3,1V11c0,2.3,0.7,4.5,2,6.4s3,3.2,5.1,3.9h0.2H12h0.2c-1-1.2-1.7-2.7-1.7-4.4C10.5,13.4,13.4,10.5,17,10.5z"/>
            <path d="M17,21.5c0.2,0,0.4-0.1,0.5-0.2s0.2-0.3,0.2-0.5v-3.1h3.1c0.2,0,0.4-0.1,0.5-0.2s0.2-0.3,0.2-0.5s-0.1-0.4-0.2-0.5s-0.3-0.2-0.5-0.2h-3.1v-3.1c0-0.2-0.1-0.4-0.2-0.5s-0.3-0.2-0.5-0.2s-0.4,0.1-0.5,0.2s-0.2,0.3-0.2,0.5v3.1h-3.1c-0.2,0-0.4,0.1-0.5,0.2s-0.2,0.3-0.2,0.5s0.1,0.4,0.2,0.5s0.3,0.2,0.5,0.2h3.1v3.1c0,0.2,0.1,0.4,0.2,0.5S16.8,21.5,17,21.5z"/>
        </IconBase>
    )
}

export default AdminAddIcon;